import { ShopOutlined, UserOutlined } from '@ant-design/icons';
import type { BtlApplication } from '@api/btlApplicationForm/types';

interface CaseSidebarApplicantsSubtitleProps {
  application: BtlApplication;
}

export function CaseSidebarApplicantsSubtitle({ application }: CaseSidebarApplicantsSubtitleProps) {
  const companiesCount = application.borrower?.companies.length ?? 0;
  const individualsCount = application.borrower?.individuals.length ?? 0;

  if (companiesCount === 0 && individualsCount === 0) {
    return null;
  }

  return (
    <div className='mt-0.5 flex items-center gap-1.5 text-xs text-gray-500'>
      {companiesCount > 0 && (
        <span className='inline-flex items-center gap-1' data-testid='companies'>
          <ShopOutlined className='text-[11px]' />
          {companiesCount}
        </span>
      )}
      {companiesCount > 0 && individualsCount > 0 && <span>/</span>}
      {individualsCount > 0 && (
        <span className='inline-flex items-center gap-1' data-testid='individuals'>
          <UserOutlined className='text-[11px]' />
          {individualsCount}
        </span>
      )}
    </div>
  );
}
